import { apiClient } from '../../services/api'

export interface AccessToken {
  access_token: string
  token_type: string
}

export type PlatformRole = 'bon8_admin' | 'bon8_staff' | 'external'

export interface CurrentUser {
  id: string
  email: string
  name: string | null
  avatar_url: string | null
  platform_role: PlatformRole
  created_at: string
}

export async function login(email: string, password: string): Promise<AccessToken> {
  const { data } = await apiClient.post<AccessToken>('/auth/login', { email, password })
  return data
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout')
}

export interface ChangePasswordPayload {
  current_password: string
  new_password: string
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await apiClient.post('/auth/change-password', payload)
}

export async function fetchCurrentUser(): Promise<CurrentUser> {
  const { data } = await apiClient.get<CurrentUser>('/users/me')
  return data
}

export async function updateCurrentUser(
  payload: Partial<Pick<CurrentUser, 'name' | 'avatar_url'>>,
): Promise<CurrentUser> {
  const { data } = await apiClient.patch<CurrentUser>('/users/me', payload)
  return data
}

export async function uploadCurrentUserAvatar(file: File): Promise<CurrentUser> {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await apiClient.post<CurrentUser>('/users/me/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
